function LegalContent({ html, title }) {
    return (
        <div className="bg-white rounded-2xl m-auto p-8 text-blue-dark">
            {title && (
                <div className="text-3xl text-golden font-bold mb-4">{title}</div>
            )}
            {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
        </div>
    );
}

export default LegalContent;
